import { Routes } from '@angular/router'
import { AuthGuardLoginService } from './services/auth-guard-login.service'
import { ExceptionComponent } from './components/exception/exception.component'
import { NavigationContextGuard } from './services/navigation-context.guard'
import { AccessToDashboardGuard } from './services/dashboard-guard.service'
import { AccountSettingsComponent } from './components/account-settings/account-settings.component'
import { AgentVerificationComponent } from './modules/user-authentication/agent-verification/agent-verification.component'
import { AgentTtEmailComponent } from './modules/user-authentication/agent-tt-email/agent-tt-email.component'
import { AgentCreateUserComponent } from './modules/user-authentication/agent-create-user/agent-create-user.component'
import { AgentLoggedOutComponent } from './modules/user-authentication/agent-logged-out/agent-logged-out.component'

export const routes: Routes = [
  {
    path: 'agent-verification',
    component: AgentVerificationComponent
  },
  {
    path: 'agent/tt-email',
    component: AgentTtEmailComponent
  },
  {
    path: 'agent/create-user',
    component: AgentCreateUserComponent
  },
  {
    path: 'agent/logged-out',
    component: AgentLoggedOutComponent
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/user-authentication/user-authentication.module').then(
        (m) => m.UserAuthenticationModule
      ),
    canActivate: [AuthGuardLoginService]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./../app/modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AccessToDashboardGuard]
  },
  {
    path: 'my-profile',
    loadComponent: () => import('./../app/modules/profiles/profiles.component').then(m => m.ProfilesComponent),
    canActivate: [AccessToDashboardGuard]
  },
  {
    path: 'my-tests',
    loadChildren: () => import('./../app/modules/my-test/my-test.module').then(m => m.MyTestModule)
  },
  {
    path: 'server-error',
    component: ExceptionComponent,
    canActivate: [NavigationContextGuard]
  },
  {
    path: 'mock-settings',
    loadChildren: () => import('./modules/mock-settings/mock-settings.module').then(m => m.MockSettingsModule)
  },
  {
    path: 'account-settings',
    component: AccountSettingsComponent
  },
  {
    path: '',
    redirectTo: 'login-initiate',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: ExceptionComponent,
    data: { type: 'pageNotFound' }
  }
]
